import { Box, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material"
import { Repeat } from "lib/@components/repeat"
import { If } from "lib/@components/switch"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { invalidate } from "lib/graphql/cache"
import { successSnackbar } from "lib/snackbar/success-snackbar"
import { errorSnackbar } from "lib/snackbar/error-snackbar"
import { confirm } from "lib/@dialogs/confirm"
import { getScimGroups } from "routes/settings/plugins/scim/controller/get-scim-group-mappings"
import { deleteScimGroup } from "routes/settings/plugins/scim/controller/delete-scim-group"
import { GroupRow } from "./group-row"

export function SyncedGroupsSection() {
    const { client } = useBoundContext()
    const clientId = client?.id
    const groups = getScimGroups.useResults({ clientId }) ?? []

    return (
        <Box sx={{ mt: 4 }}>
            <Typography variant="subtitle1" gutterBottom>
                Synced groups
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                Groups currently stored in FIQ from your IdP. Delete any that are no longer needed — this removes the
                group record and any associated mappings, and reconciles affected users.
            </Typography>

            <If value={groups.length > 0}>
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell>Display name</TableCell>
                            <TableCell>External ID</TableCell>
                            <TableCell align="center">Members</TableCell>
                            <TableCell sx={{ width: 48 }} align="right" />
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <Repeat
                            list={groups}
                            item={<GroupRow onDelete={handleDelete} />}
                            keyFn={groupKeyFn}
                            pass="group"
                        />
                    </TableBody>
                </Table>
            </If>
        </Box>
    )

    async function handleDelete(group) {
        const confirmed = await confirm(
            `Delete "${group.displayName}"? This removes the group record and any associated mappings. Affected members will be reconciled.`,
            "Delete synced group"
        )
        if (!confirmed) return
        try {
            await deleteScimGroup({ id: group._id, clientId })
            invalidate("getScimGroups")
            invalidate("getScimGroupMappings")
            successSnackbar(`"${group.displayName}" removed — affected users reconciled`)
        } catch (error) {
            errorSnackbar(error?.message || "Delete failed")
        }
    }
}

function groupKeyFn(g) {
    return g._id
}
